<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [erroremessage]="erroremessage"
  [columns]="columns"
  (valueChange)="onMasterChanged($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="salemethodid">
      <ssg-select
        name="SaleMethodId"
        [group]="formGroup"
        tabOrder="0"
        class="SaleMethod"
        [label]="'ClientApp.FrontOffice.SALE.SaleMethod.SaleMethod' | translate"
        [dataList]="SaleMethodList"
        textFieldName="Title"
        valueFieldName="Id"
        (valueChange)="SaleMethodChange($event)">
      </ssg-select>
    </div>
    <ssg-tabset class="tabcontentbox contentbox saleMethodBranchForm" (tabChange)="selectTab($event)">
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.SALE.SaleMethod.Setting' | translate">
        <div class="row setting">
          <div class="col-lg-12" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Delivery">
            <ssg-select
              name="DeliveryCustomerPrintTimeId"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.PrintCustomer' | translate"
              apiName="Lookup"
              [group]="formGroup"
              systemName="SALE"
              category="DeliveryCustomerPrintTime"
              required="false"
              (valueChange)="onChanged($event,1)"
              textFieldName="Title"
              valueFieldName="Id">
            </ssg-select>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox id="ApplyTax" name="ApplyTax" [group]="formGroup" [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplyTax' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="ApplyService"
              name="ApplyService"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplyService' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="ApplyTaxForService"
              name="ApplyTaxForService"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplyTaxForService' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="ApplyTaxForPackingPrice"
              name="ApplyPackingPrice"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplyPackingPrice' | translate ">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Delivery">
            <ssg-checkbox
              id="IsBarCodeInvoice"
              name="IsBarCodeInvoice"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsBarCodeInvoice' | translate ">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Delivery">
            <ssg-checkbox
              id="HasDeposit"
              name="HasDeposit"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasDeposit' | translate ">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="ApplyTaxForPackingPrice"
              name="ApplyTaxForPackingPrice"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplyTaxForPackingPrice' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Delivery">
            <ssg-checkbox
              id="ApplyTaxForShippingCost"
              name="ApplyTaxForShippingCost"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplyTaxForShippingCost' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="TableIsRequired"
              name="TableIsRequired"
              (valueChange)="TableIsRequiredvalueChange($event)"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.TableIsRequired' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IncludeFreeItemDependency"
              name="IncludeFreeItemDependency"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IncludeFreeItemDependency' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IncludeItemDependency"
              name="IncludeItemDependency"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IncludeItemDependency' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="WaiterIsRequired"
              name="WaiterIsRequired"
              (valueChange)="waiterIsRequiredvalueChange($event)"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.WaiterIsRequired' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="NumberOfGuestsIsRequired"
              name="NumberOfGuestsIsRequired"
              (valueChange)="NumberOfGuestsIsRequiredvalueChange($event)"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.NumberOfGuestsIsRequired' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Restaurant">
            <ssg-checkbox
              id="HasOnlineRezerv"
              name="HasOnlineRezerv"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasOnlineRezerv' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox id="HasSnap" name="HasSnap" [group]="formGroup" [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplySnap' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Delivery">
            <ssg-checkbox
              id="HasDelino"
              name="HasDelino"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplyDelino' | translate">
            </ssg-checkbox>
          </div>

          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="ShowSalonName"
              name="ShowSalonName"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ShowSalonName' | translate ">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="ShowCustomerInfo"
              name="ShowCustomerInfo"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ShowCustomerInfo' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="ShowWaiterName"
              name="ShowWaiterName"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ShowWaiterName' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
            <ssg-checkbox
              id="ShowNumberOfGuests"
              name="ShowNumberOfGuests"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ShowNumberOfGuests' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="HasKeyboardOrder"
              name="HasKeyboardOrder"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasKeyboardOrder' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="HasNecessaryMobile"
              name="HasNecessaryMobile"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ShowCustomerNecessary' | translate ">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="HasNecessaryName"
              name="HasNecessaryName"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasNecessaryName' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              name="PreprationTimeIsActive"
              [group]="formGroup"
              (valueChange)="PreprationTimeIsActiveValueChange($event)"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.PreprationTimeIsActive' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              name="ShowDescInvKitchen"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ShowDescInvKitchen' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              name="ShowDescInvCustomer"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ShowDescInvCustomer' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              name="HasHappyHour"
              [group]="formGroup"
              (valueChange)="HappyHourValueChange($event)"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasHappyHour' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox name="ItemCountDisplay" [group]="formGroup" [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ItemCountDisplay' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="IsActivePreparationTime">
            <ssg-checkbox
              name="PreprationTimeRequired"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.PreprationTimeRequired' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-12 divider"></div>
          <div class="col-lg-6 Detailalighn" *ngIf="HasHappyHour">
            <date-picker
              name="HappyHourFromDate"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HappyHourFromDate' | translate"
              required="false"
              textType="date"
              disabled="false">
            </date-picker>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="HasHappyHour">
            <date-picker
              name="HappyHourToDate"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HappyHourToDate' | translate"
              required="false"
              textType="date"
              disabled="false">
            </date-picker>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="HasHappyHour">
            <time-picker
              name="HappyHourStart"
              class="HappyHourStart select-shr"
              [group]="formGroup"
              required="false"
              textType="number"
              [showSeconds]="false"
              (valueChange)="HappyHourStratValueChange($event)"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HappyHourStart' | translate"></time-picker>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="HasHappyHour">
            <time-picker
              name="HappyHourEnd"
              class="HappyHourEnd"
              textType="number"
              [group]="formGroup"
              [showSeconds]="false"
              required="false"
              (valueChange)="HappyHourEndValueChange($event)"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HappyHourEnd' | translate">
            </time-picker>
          </div>
          <div class="col-lg-6 Detailalighn salecount" *ngIf="HasHappyHour">
            <div class="sale">
              <div class="salebox">
                <div class="toggle">
                  <button
                    class="togglebtn"
                    (click)="applyDiscount(null, true); focus('Discount')"
                    [ngClass]="{ active: this.model.IsDiscountPercent }">
                    {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Percent" | translate }}
                  </button>
                  <button
                    class="togglebtn"
                    (click)="applyDiscount(null, false); focus('Discount')"
                    [ngClass]="{ active: !this.model.IsDiscountPercent }">
                    {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.UnitOfPrice" | translate }}
                  </button>
                </div>
                <ssg-input
                  [group]="formGroup"
                  icon="icon-close-o"
                  class="saleinput"
                  name="Discount"
                  #DiscountBox
                  textType="text"
                  inputMode="numeric"
                  isNumberOnly="true"
                  [isFloat]="currentBranch?.HasDecimal || false"
                  hasClear="true"
                  (clear)="clearDiscount()"
                  autocomplete="off"
                  (focus)="onDiscountfocus()"
                  (onEnter)="applyDiscount($event, null)"
                  (oninput)="applyDiscount($event, null)"
                  [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Sale' | translate">
                </ssg-input>
              </div>
            </div>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="HasHappyHour">
            <ssg-select
              name="DaysOfWeek"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.DaysOfWeek' | translate"
              [dataList]="DaysOfWeekList"
              systemName="SALE"
              category="DaysWeek"
              textFieldName="Title"
              valueFieldName="Id"
              [group]="formGroup"
              [multiple]="true"></ssg-select>
          </div>
          <div class="d-flex">
            <div class="col-lg-6" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Restaurant">
              <ssg-input
                class="MaximumTimeForStay"
                userClass="select-sm"
                id="MaximumTimeForStay"
                name="MaximumTimeForStay"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.MaximumTimeForStay' | translate"
                textType="number"
                [max]="9999">
              </ssg-input>
            </div>
            <div class="col-lg-6">
              <ssg-input
                [group]="formGroup"
                name="FirstNumberingInDate"
                userClass="select-sm"
                [isNumberOnly]="true"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.FirstNumberingInDate' | translate"
                style="width: 100% !important"
                textType="number"
                [max]="9999">
              </ssg-input>
            </div>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="HasHappyHour">
            <ssg-checkbox
              *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery else serviceTemplate"
              id="FreeService"
              name="FreeService"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.FreeService' | translate"
              required="false"
              disabled="false">
            </ssg-checkbox>
            <ng-template #serviceTemplate>
              <ssg-checkbox
                id="FreeShipping"
                name="FreeShipping"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.FreeShipping' | translate"
                required="false"
                disabled="false">
              </ssg-checkbox>
            </ng-template>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.SALE.SaleMethod.Relative' | translate">
        <div class="relation">
          <div class="set-relation">
            <div>
              <ssg-select
                name="ItemCategoryIdList"
                [group]="formGroup"
                multiple="true"
                [dataList]="ItemCategory"
                tabOrder="0"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.GoodsGroupExeption' | translate"
                (valueClear)="onClear(0)"
                (removeItem)="onRemoveItem($event,0)"
                (addItem)="onAddItem($event,0)"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div>
              <ssg-select
                *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery"
                name="PaymentMethodIdList"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.PaymentMethodExeption' | translate"
                [dataList]="PaymentMethod"
                multiple="true"
                tabOrder="2"
                (valueClear)="onClear(2)"
                (removeItem)="onRemoveItem($event,2)"
                (addItem)="onAddItem($event,2)"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div>
              <ssg-select
                name="SalePriceTypeIdList"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.SalePriceTypeExeption' | translate"
                [dataList]="SalePriceType"
                multiple="true"
                (valueClear)="onClear(4)"
                (removeItem)="onRemoveItem($event,4)"
                (addItem)="onAddItem($event,4)"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div>
              <ssg-select
                name="PrintTemplateIdList"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.PrintTemplatesExeption' | translate"
                [dataList]="PrintTemplate"
                multiple="true"
                (valueClear)="onClear(6)"
                (removeItem)="onRemoveItem($event,6)"
                (addItem)="onAddItem($event,6)"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery">
              <ssg-select
                name="SalonLookup"
                [group]="formGroup"
                [dataList]="SalonLookupList"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.SalonsExeption' | translate"
                apiName="Salon/ReadLookUp"
                multiple="true"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
          </div>
          <div class="set-relation">
            <div>
              <ssg-select
                name="ItemCategoriesDefaultId"
                [group]="formGroup"
                tabOrder="6"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.GoodsGroupDefault' | translate"
                [dataList]="ItemCategoriesDefaultList"
                (valueClear)="onClear(1)"
                (valueChange)="onChanged($event,1)"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div>
              <ssg-select
                *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.Delivery"
                name="PaymentMethodDefaultId"
                [group]="formGroup"
                tabOrder="1"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.PaymentMethodDefault' | translate"
                [dataList]="PaymentMethodDefaultList"
                (valueClear)="onClear(3)"
                (valueChange)="onChanged($event,3)"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div>
              <ssg-select
                name="SalePriceTypeDefaultId"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.SalePriceTypeDefault' | translate"
                [dataList]="SalePriceTypeDefaultList"
                (valueClear)="onClear(5)"
                (valueChange)="onChanged($event,5)"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
            <div>
              <ssg-select
                name="CustomerCategoriesLookup"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.CustomerCategoryExeption' | translate"
                apiName="CustomerCategory/ReadLookUp"
                multiple="true"
                textFieldName="Title"
                valueFieldName="Id">
              </ssg-select>
            </div>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.SALE.SaleMethod.FastAccess' | translate">
        <div class="row fastaccess">
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsChangeTheSalesMethod"
              name="IsChangeTheSalesMethod"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsChangeTheSalesMethod' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsSalonFastAccess"
              name="IsSalonFastAccess"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsSalonFastAccess' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsDriverAssignmentFastAccess"
              name="IsDriverAssignmentFastAccess"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsDriverAssignmentFastAccess' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsCustomreFastAccess"
              name="IsCustomreFastAccess"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsCustomreFastAccess' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsWaiterFastAccess"
              name="IsWaiterFastAccess"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsWaiterFastAccess' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsPagerFastAccess"
              name="IsPagerFastAccess"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsPagerFastAccess' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsClubFastAccess"
              name="IsClubFastAccess"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsClubFastAccess' | translate"
              (valueChange)="this.model.IsClubFastAccess = !this.model.IsClubFastAccess">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="IsPaymentLink"
              name="IsPaymentLink"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.IsPaymentLink' | translate"
              (valueChange)="this.model.IsPaymentLink = !this.model.IsPaymentLink">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              *ngIf="this.model.HasDelino"
              id="HasDelinoOfflineFactor"
              name="HasDelinoOfflineFactor"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasDelinoOfflineFactor' | translate"
              (valueChange)="this.model.HasDelinoOfflineFactor = !this.model.HasDelinoOfflineFactor">
            </ssg-checkbox>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.SALE.SaleMethod.Inventory'" *ngIf="hasInv">
        <div class="mt-3">
          <div class="d-flex">
            <div class="inv-setting ml-4">
              <ssg-select
                name="InvVoucherId"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.TypesOfDocsForSendSale' | translate"
                textFieldName="Title"
                valueFieldName="Id"
                [apiName]="'InvVoucherKind/ReadLookUp'">
              </ssg-select>
            </div>
            <div class="inv-setting">
              <ssg-select
                name="InvWareHouseId"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.InvForSendSale' | translate"
                textFieldName="Title"
                valueFieldName="Id"
                [apiName]="'Warehouse'">
              </ssg-select>
            </div>
          </div>
          <div class="d-flex" *ngIf="model.HasDeposit">
            <div class="inv-setting ml-4">
              <ssg-select
                name="InvDepositVoucherKindId"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.TypesOfDocsForDepositInfo' | translate"
                textFieldName="Title"
                valueFieldName="Id"
                [apiName]="'InvVoucherKind/ReadLookUp'">
              </ssg-select>
            </div>
            <div class="inv-setting">
              <ssg-select
                name="InvDepositWareHouseId"
                [group]="formGroup"
                [label]="'ClientApp.FrontOffice.SALE.SaleMethod.InvForSendDepositInfo' | translate"
                textFieldName="Title"
                valueFieldName="Id"
                [apiName]="'Warehouse'">
              </ssg-select>
            </div>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.SALE.SaleMethod.IsClubFastAccess' | translate" *ngIf="this.model.IsClubFastAccess">
        <div class="row">
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="UseMobileInValidation"
              name="UseMobileInValidation"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.UseMobileInValidation' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="SaleMethodNatureCode === _saleMethodNature.FastFood">
            <ssg-checkbox
              id="InPerson"
              name="InPerson"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.InPerson' | translate"
              (valueChange)="onInPersonChanges($event)">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="HasSnap"
              name="HasSnap"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.ApplySnap' | translate"
              (valueChange)="onApplySnap($event)">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="AutoApplySnap"
              name="AutoApplySnap"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.AutoApplySnap' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="hasMarriageDate"
              name="hasMarriageDate"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.hasMarriageDate' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="hasBirthdayDate"
              name="hasBirthdayDate"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.hasBirthdayDate' | translate">
            </ssg-checkbox>
          </div>
        </div>
      </ssg-tab>
      <ssg-tab
        [tabTitle]="'ClientApp.FrontOffice.SALE.SaleMethod.PaymentLink' | translate"
        *ngIf="model.IsPaymentLink && currentInformation?.PaymentPanelAVA">
        <div class="row">
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="HasFactorLink"
              name="HasFactorLink"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasFactorLink' | translate "
              (valueChange)="onHasFactorChanges($event)">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode !== _saleMethodNature.FastFood">
            <ssg-checkbox
              id="HasPaymentLink"
              name="HasPaymentLink"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasPaymentLink' | translate"
              (valueChange)="onPaymentLinkChanges($event)">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              id="AutomaticLinks"
              name="AutomaticLinks"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.AutomaticLinks' | translate"
              (valueChange)="onAutomaticLinksChanges($event)">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn" *ngIf="this.SaleMethodNatureCode === _saleMethodNature.Delivery">
            <ssg-checkbox
              id="HasPaymentLinkForNewCustomer"
              name="HasPaymentLinkForNewCustomer"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.HasPaymentLinkForNewCustomer' | translate"
              (valueChange)="onHasPaymentLinkForNewCustomerChanges($event)">
            </ssg-checkbox>
          </div>
          <div class="col-lg-6 Detailalighn">
            <ssg-checkbox
              *ngIf=" this.SaleMethodNatureCode === _saleMethodNature.Delivery"
              id="PrintForOnlineOrderForNewCustomer"
              name="PrintForOnlineOrderForNewCustomer"
              [group]="formGroup"
              [label]="'ClientApp.FrontOffice.SALE.SaleMethod.PrintForOnlineOrderForNewCustomer' | translate">
            </ssg-checkbox>
          </div>
          <div class="col-lg-8 Detailalighn" style="margin-top: 10px">
            <ssg-select
              *ngIf="formGroup?.value?.HasPaymentLink"
              name="PaymentId"
              [group]="formGroup"
              [label]="'ClientApp.GNR.Branch.paymentMethod' | translate"
              [dataList]="PaymentMethodData"
              textFieldName="Title"
              valueFieldName="Id"
              [required]="!!formGroup?.value?.HasPaymentLink"
              [filterKey]="'PaymentMethodCode'"
              [filterValue]="3">
            </ssg-select>
          </div>
        </div>
      </ssg-tab>
    </ssg-tabset>
    <ssg-tabset class="tabcontentbox tabcontainer" *ngIf="isAccessToAllBranches">
      <ssg-tab
        [tabTitle]="'ClientApp.FrontOffice.Catalog.Item.Branch' | translate"
        *ngIf="Branchescolumns?.length > 0 && !model?.Id && branchShow && currentBranch.AccessToAllBranches">
        <editable-grid
          [DefaultValues]="DefaultValues"
          [columns]="Branchescolumns"
          [hideToolber]="true"
          [dataList]="Branches"
          [isAdd]="false"
          [isDelete]="false">
        </editable-grid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
